/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

//
// Warning: Notification is created with a string copy of this directive's HTML.
//    - Copying strings means buttons will not invoke this directive's functions.
//    - Also, when directive's template changes, the notification won't update.
// To workaround these issues, directive replaces a portion of the copied HTML
// with the directive's original HTML elements.
//    - The portion that isn't copied uses dynamic values set by the notification.
//    - Notice: Any HTML outside of the replaced HTML will not change.
//        - aka: Can't use ng-*** outside of the replaced HTML.
//

/**
 * Created by bbonet on 1/28/15.
 */
'use strict';
angular.module('prism-ui.components').directive('notificationDirective', function ($window) {

    return {
        restrict: 'E',
        templateUrl: 'components/notification/notification-template.html',
        replace: true,
        link: function (scope, iElement, iAttrs) {

            //This directive requires Bootstrap Growl.
            //Details on options and settings for bootstrap growl can be found here: http://bootstrap-growl.remabledesigns.com/
            var options = {};

            if (scope.message) {
                options.message = scope.message;
            }

            if (scope.icon) {
                options.icon = scope.icon;
            }

            if (scope.title) {
                options.title = scope.title;
            }

            var settings = {};
            var notificationVisible = true;

            settings.template = iElement[0].outerHTML;
            settings.onClose = function () {
                notificationVisible = false;
            };

            if (scope.element) {
                settings.element = scope.element; //default: body
            }

            if (scope.type) {
                settings.type = scope.type; //default: info
            }

            if (scope.allow_dismiss !== null && typeof scope.allow_dismiss !== 'undefined') {
                settings.allow_dismiss = scope.allow_dismiss; //default: true
            }

            if (scope.placement) {
                settings.placement = {};
                if (scope.placement.from) {
                    settings.placement.from = scope.placement.from; //default: top
                }
                if (scope.placement.align) {
                    settings.placement.align = scope.placement.align; //default: right
                }
            } else {
                settings.placement = {};
                settings.placement.from = 'bottom';
                settings.placement.align = 'left';
            }

            settings.offset = {
                x: 20,
                y: 32
            };
            if (typeof scope.offset === 'number') {
                settings.offset.x = scope.offset;
                settings.offset.y = scope.offset;
            } else if (scope.offset) {
                if (scope.offset.x) {
                    settings.offset.x = scope.offset.x;
                }
                if (scope.offset.y) {
                    settings.offset.y = scope.offset.y;
                }
            }

            settings.z_index = scope.z_index || 1000000; //default: 1031

            if (scope.spacing) {
                settings.spacing = scope.spacing; //default: 10
            }

            if (scope.delay) {
                settings.delay = scope.delay; //default: 5000
            }

            if (scope.timer) {
                settings.timer = scope.timer; //default: 1000
            }

            if (scope.mouse_over !== null && typeof scope.mouse_over !== 'undefined') {
                settings.mouse_over = scope.mouse_over; //default: false
            }

            if (!scope.animate) {
                scope.animate = {};
            }
            settings.animate = {
                enter: scope.animate.enter || 'animate__animated animate__fadeInDown animate__fast',
                exit: scope.animate.exit || 'animate__animated animate__fadeOutDown animate__fast'
            };

            if (scope.onShow) {
                settings.onShow = scope.onShow; //default: null
            }

            if (scope.onShown) {
                settings.onShown = scope.onShown; //default: null
            }

            if (scope.onHide) {
                settings.onHide = scope.onHide; //default: null
            }

            if (scope.onHidden) {
                settings.onHidden = scope.onHidden; //default: null
            }

            if (scope.icon_type) {
                settings.icon_type = scope.icon_type; //default: class
            }

            scope.api = $.notify(options, settings);
            var messageContainerElem = scope.api.$ele.find('.alert-message')[0];
            var messageElem = scope.api.$ele.find('[data-notify="message"]')[0];
            var expandButtonElem = iElement.find('.expand.close')[0];
            var longMessageIndicatorElem = iElement.find('.alert-long-message')[0];

            var dynamicElements = ['.expand.close', '.dynamic-notification-content'];
            dynamicElements.forEach(function (searchString) {
                scope.api.$ele.find(searchString).replaceWith(iElement.find(searchString));
            });

            var onFrameRendered = function () {
                if (notificationVisible) {
                    let tooWide = messageElem.offsetWidth > messageContainerElem.offsetWidth;
                    let tooTall = messageElem.offsetHeight > messageContainerElem.offsetHeight;
                    if (tooTall) {
                        longMessageIndicatorElem.classList.remove('ng-hide');
                    } else {
                        longMessageIndicatorElem.classList.add('ng-hide');
                    }
                    if (tooWide || tooTall) {
                        expandButtonElem.classList.remove('ng-hide');
                    } else {
                        expandButtonElem.classList.add('ng-hide');
                    }
                    $window.requestAnimationFrame(onFrameRendered);
                }
            };
            $window.requestAnimationFrame(onFrameRendered);

            scope.expandMessageClicked = function () {
                let originalMessage = (scope.fileErrorsObject) ? scope.fileErrorsObject : scope.message;
                scope.longerMessageCallback(options.message, originalMessage);
            };
        }
    };
});
